module.exports = {
      id: "play-usage",
      viewBox: "0 0 30.542 30.542",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#play",
      toString: function () {
        return this.url;
      }
    }